import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BadgeItemModel, BadgeWelcomeStateModel } from '../achievements.model';

const WELCOME_PREVIEW_COUNT = 4;

/**
 * One-time "Achievements are live!" announcement shown after launch. Both buttons dismiss it
 * permanently (server flag); "See all achievements" additionally opens the achievements page.
 */
@Component({
  selector: 'app-achievements-welcome-dialog',
  templateUrl: './achievements-welcome-dialog.component.html',
  styleUrls: ['./achievements-welcome-dialog.component.scss'],
})
export class AchievementsWelcomeDialogComponent {
  readonly state: BadgeWelcomeStateModel;
  readonly preview: BadgeItemModel[];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BadgeWelcomeStateModel,
    private dialogRef: MatDialogRef<AchievementsWelcomeDialogComponent>,
    private router: Router
  ) {
    this.state = data;
    this.preview = (data?.badges || []).slice(0, WELCOME_PREVIEW_COUNT);
  }

  get hiddenCount(): number {
    return Math.max(0, (this.state?.badges?.length || 0) - this.preview.length);
  }

  seeAll(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/profile/achievements']);
  }

  skip(): void {
    this.dialogRef.close(false);
  }
}
